// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 20H21V10C21 4.39943 16.4712 1 12 1C7.52879 1 3 4.39943 3 10V20H2V22H10V20H9V11H15V20H14V22H22V20ZM17 11H19V20H17V11ZM5 11H7V20H5V11ZM14 7H10V5H14V7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dam-3-filled')
export default class Dam3FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-3-filled',
    }
  }
}
